var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { attrs: { id: "appRecommendMobile" } }, [
          _c("div", {
            staticClass: "app-recommend-mobile-close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "app-recommend-mobile-title" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("language.popup.appRecommendPopup.modileTitle")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.mobileType == "IOS"
            ? _c("div", { staticClass: "app-recommend-mobile-img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/images/appRecommend/app_ios_phone_mobile.png")
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileType != "IOS"
            ? _c("div", { staticClass: "app-recommend-mobile-img" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/images/appRecommend/app_android_phone_mobile.png")
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "app-recommend-mobile-tips",
            style: _vm.mobileType == "IOS" ? "padding: 12vw 0;" : "",
            domProps: {
              innerHTML: _vm._s(_vm.$t("language.popup.appRecommendPopup.tip"))
            }
          }),
          _vm._v(" "),
          _vm.mobileType == "IOS"
            ? _c("div", { staticClass: "app-recommend-mobile-btns" }, [
                _c(
                  "div",
                  {
                    staticClass: "app-recommend-mobile-btn ios-btn",
                    on: {
                      click: function($event) {
                        return _vm.jumpToIosDownload()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "app-recommend-mobile-btn-img" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "app-recommend-mobile-btn-tips" },
                      [
                        _vm.getbtnType("ios") == 1
                          ? _c(
                              "div",
                              { staticClass: "app-recommend-mobile-btn-tip" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.appRecommendPopup.iosBtnTitle"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "app-recommend-mobile-btn-title" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.appRecommendPopup.iosBtnTip"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.getbtnType("ios") == 2
                          ? _c(
                              "div",
                              { staticClass: "app-recommend-mobile-btn-tip" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.appRecommendPopup.iosBtnTitle"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileType != "IOS"
            ? _c("div", { staticClass: "app-recommend-mobile-btns" }, [
                _c(
                  "div",
                  {
                    staticClass: "app-recommend-mobile-btn apk-btn",
                    on: {
                      click: function($event) {
                        return _vm.jumpToAPKDownload()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "app-recommend-mobile-btn-img" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "app-recommend-mobile-btn-tips" },
                      [
                        _vm.getbtnType("apk") == 1
                          ? _c(
                              "div",
                              { staticClass: "app-recommend-mobile-btn-tip" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.appRecommendPopup.apkBtnTitle"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "app-recommend-mobile-btn-title" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.appRecommendPopup.apkBtnTip"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.getbtnType("apk") == 2
                          ? _c(
                              "div",
                              { staticClass: "app-recommend-mobile-btn-tip" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.appRecommendPopup.apkBtnTitle"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "app-recommend-mobile-btn google-btn",
                    on: {
                      click: function($event) {
                        return _vm.jumpToAndroidDownload()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "app-recommend-mobile-btn-img" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "app-recommend-mobile-btn-tips" },
                      [
                        _vm.getbtnType("android") == 1
                          ? _c(
                              "div",
                              { staticClass: "app-recommend-mobile-btn-tip" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.appRecommendPopup.androidBtnTitle"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "app-recommend-mobile-btn-title" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.appRecommendPopup.androidBtnTip"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.getbtnType("android") == 2
                          ? _c(
                              "div",
                              { staticClass: "app-recommend-mobile-btn-tip" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.appRecommendPopup.androidBtnTitle"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6d0f48a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6d0f48a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/activity_popups/app_recommend_mobile_popup.vue
// module id = null
// module chunks = 